import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AssinaturaSucesso = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [open, setOpen] = useState(true);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleIrParaLogin = () => {
    setOpen(false);
    localStorage.removeItem('gestaopsi_user');
    localStorage.removeItem('token');
    localStorage.removeItem('user_permissions');
    localStorage.removeItem('user');
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ maxWidth: 820, mx: 'auto', mt: 4, px: 2 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Pagamento confirmado
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Você pode fechar esta tela e entrar no sistema.
          </Typography>
        </CardContent>
      </Card>

      <Dialog open={open} onClose={handleIrParaLogin} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CheckCircleOutlineIcon color="success" />
          <span>Assinatura confirmada</span>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1 }}>
            Obrigado! Seu pagamento foi confirmado.
          </Typography>
          <Typography sx={{ mb: 2 }}>
            Você receberá uma confirmação por e-mail. Para acessar o sistema, entre em:
            <strong> trajetus.net/login</strong>
          </Typography>
          {sessionId ? (
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              Sessão: {sessionId}
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleIrParaLogin}>
            Ok, ir para o login
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssinaturaSucesso;
